import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

export const search = createApiAction('person/lookup/search', client.search('/api/person/lookup'))

const slice = createSlice({
  name: 'personLookup',
  initialState: { list: null, count: null, loading: false, query: {} },
  reducers: {
    setQuery: (state, action) => { state.query = action.payload },
  },
  extraReducers(builder) {
    builder
      .addCase(search.pending, state => { state.loading = true })
      .addCase(search.fulfilled, (state, action) => {
        state.list = action.payload.rows
        state.count = action.payload.count
        state.loading = false
      })
  },
})

export const { setQuery } = slice.actions
export default slice.reducer
